import { compose, mergeDeepRight } from 'ramda';

/**
 * @typedef {Object} GtmTagStructure
 * @property {GaEventData.GTM_KEYS|string}  gtmTagStructure[key] - value of any string or GTM_KEY_GETTERS key... eg. DEVICE (gets device)
 *
 * @typedef {Object} GaEventData
 * @property {Function} gaEventData.condition e.g customer=>boolean defaults to TRUE
 * @property {object} gaEventData.CONSTANTS - default constants value
 * @property {object} gaEventData.GTM_KEY_GETTERS - default key getters from data - e.g data=>data.id
 * @property {GtmTagStructure} gaEventData.struct - ga event structure
 *
 *
 * @typedef {Object} GaConfig
 * @property {GaEventData} GaConfig[event]
 *
 * gtmUtils.GTM_KEY_GETTERS for default values of Getters
 * gtmUtils.CONSTANTS for default values of constants
 * gtmUtils.GA_EVENTS_KEYS for default values of events
 *
 * Provide CONSTANTS or GTM_KEY_GETTERS to override
 * {
 *  CONSTANTS:{
 *    NEW_CONSTANT:'new_constant'
 *  },
 *  GTM_KEY_GETTERS:{
 *    NEW_GTM_KEY:(data)=>value
 *  }
 * }
 *
 */
let gaConfig = {
  gaLogout: {
    struct: {
      event: 'log_out',
      userId: 'CUSTOMER_ID',
    },
  },
  gaSignIn: {
    struct: {
      event: 'sign_in',
      method: 'AUTH_METHOD',
      userId: 'CUSTOMER_ID',
    },
  },
  gaSignUp: {
    struct: {
      event: 'sign_up',
      method: 'AUTH_METHOD',
      userId: 'CUSTOMER_ID',
    },
  },
  gaNewOrder: {
    struct: {
      event: 'newOrder',
      userId: 'CUSTOMER_ID',
    },
  },
};

export const mergeConfig = config => newConfig => {
  gaConfig = mergeDeepRight(config, newConfig);
};

export const parse = obj => {
  try {
    return JSON.parse(obj);
  } catch (e) {
    return {};
  }
};

export const bbExtendGa4Config = compose(mergeConfig(gaConfig), parse);

/**
 * Extend existing GA4 config. Accepts only JSON.
 */
bbExtendGa4Config(typeof window !== 'undefined' && window.BB_GA4_CONFIG);

export default gaConfig;
